import { createAsyncThunk } from '@reduxjs/toolkit';
import { getApi } from 'redux/apis';

export const getConfigurationFieldAction = createAsyncThunk(
	'configurations/fields',
	async (query: any, { rejectWithValue }) => {
		try {
			const response = await getApi('/configuration', {
				...query,
				companyId: localStorage.getItem('companyId'),
			});

			return response.data.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);
